export const escapeSpecialSymbols = (str: string) => str.replace(/\[|\\|\^|\$|\.|\||\?|\*|\+|\(|\)/g, '\\$&')

export type ACCEPTED_MIME_TYPES = 'image/png' | 'image/jpeg'

// TODO: @Serginyo90 write tests
export const testImageType = (fileType: ACCEPTED_MIME_TYPES) => {
  const IMAGE_MIMES_REGEX = /image\/(png|jpeg)/
  return IMAGE_MIMES_REGEX.test(fileType)
}

// TODO: @Serginyo90 write tests
export const resolveFileExtensions = (fileType: ACCEPTED_MIME_TYPES) => {
  if (fileType && fileType.length) {
    return fileType.slice(fileType.length - 3) === 'png' ? 'png' : 'jpg'
  }
  return 'jpg'
}
